module.exports = function(fn) {
  var signal;
  signal = this;
  return signal.derive(function(send) {
    return signal.subscribe(function(val) {
      return send(fn(val));
    });
  });
};
